import cn from "@utils/cn";

import CardHeader from "@components/card/CardHeader";

import "./Card.scss";

const CLASS_NAMES = cn(`
  flex
  flex-col
  gap-6
  px-5
  py-4
  rounded-none
  md:rounded-xl
  border

  bg-white
  text-gallery-800
  border-gallery-300
`);

const defaultProps = {
  isAdminOnly: false,
  isPreview: false,
};

export default function Card(props) {
  const {
    as: Element = "div",
    id,
    title,
    icon,
    badge,
    linkUrl,
    button,
    actionMenuItems,
    isAdminOnly: _isAdminOnly,
    isPreview: _isPreview,
    className: classNameProp,
    children,
    ...elementProps
  } = props;

  const isAdminOnly = props.isAdminOnly ?? defaultProps.isAdminOnly;
  const isPreview = props.isPreview ?? defaultProps.isPreview;

  /**************************************************************************************************/

  const classNames = cn(CLASS_NAMES, classNameProp);

  return (
    <Element
      id={id}
      className={classNames}
      {...elementProps}
    >
      {title && (
        <CardHeader
          title={title}
          icon={icon}
          badge={badge}
          linkUrl={linkUrl}
          button={button}
          actionMenuItems={actionMenuItems}
          isAdminOnly={isAdminOnly}
          isPreview={isPreview}
        />
      )}

      {children}
    </Element>
  );
}
